'use strict';
module.exports = {
	id: darc.types.primary(String),
	serializedValue: Object,
	parsedValue: Object
};
